/**
 * Static Assets Constants
 * URLs for static assets hosted on S3
 */

export const STATIC_ASSETS_BASE_URL = 'https://vip-experience-static-assets.s3.amazonaws.com';
export const PLATFORM_ASSETS_URL = `${STATIC_ASSETS_BASE_URL}/platform`;

/**
 * Favicon URLs for different themes and sizes
 */
export const FAVICONS = {
    light: {
        '16': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20Main%2016px%20White%20Round%20BG.png`,
        '32': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20Main%2032px%20White%20Round%20BG.png`,
        '48': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20Main%2048px%20White%20Round%20BG.png`
    },
    dark: {
        '16': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20Black%2016px%20White%20Round%20BG.png`,
        '32': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20Black%2032px%20White%20Round%20BG.png`,
        '48': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20Black%2048px%20White%20Round%20BG.png`
    },
    loading: {
        '16': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20White%2016px%20Black%20Round%20BG.png`,
        '32': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20White%2032px%20Black%20Round%20BG.png`,
        '48': `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTALFav%20Icon%20White%2048px%20Black%20Round%20BG.png`
    }
};

/**
 * Navbar Logo URLs
 */
export const NAVBAR_LOGOS = {
    icon: `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTAL_Fav%20Icon%20Main%2048px.png`,
    horizontal: `${PLATFORM_ASSETS_URL}/EXP_MAIN_LOGO_HORIZONTAL_Main%20Logo%20Black.png`
};

/**
 * App metadata
 */
export const APP_TITLE = 'Experience';
